export function formatNumber(num: number): string {
  return new Intl.NumberFormat('es-MX', { style: 'decimal', maximumFractionDigits: 2 }).format(num)
}
